export interface WorldTransferPreparedMessage {
  receiptId: string;
  destinationMapId: string;
  destinationSpawnId?: string;
  expiresAt: number;
}

export interface WorldTransferArrivalMessage {
  receiptId: string;
  success: boolean;
  destinationMapId?: string;
  reason?: string;
  run?: {
    runId: string;
    mode: 'ranked' | 'practice';
    status: string;
    startedAt: number;
    categoryId: string;
    rulesetId: string;
  };
}

export interface WorldTransferRejectedMessage {
  reason?: string;
  /** With `portal_quest_required`: the quest that opens the portal (plan 27 D50). */
  requiredQuestId?: string;
}

/**
 * The join-refusal code a room's onAuth throws when the join's transfer
 * receipt cannot be used (expired, already spent past its deadline, unknown,
 * bound to someone else). The receipt's own reason stays on the server; the
 * client drops the receipt from its boot URL and joins once more without it
 * (src/game/services/travel/transferReceipt.ts) instead of re-sending it.
 */
export const WORLD_TRANSFER_RECEIPT_REFUSED = 'worldTransferReceiptRefused';
